import React from 'react';
import JobsList from '../JobsList';
import Copyrights from '../Copyrights';
import Footer from '../Footer';
import SEO from '../SEO';
import jobsData from '../../assets/data/jobs/jobs.json';

export default function Jobs() {
  return (
    <>
      <SEO
        title='Jobs'
        description='Explore open technology roles from across the industry — cloud, DevOps, AI, and cybersecurity opportunities curated by IURIX.'
        path='/jobs'
      />
      <main className='jobs'>
        <div className='section-header'>
          <h1>Open Roles We're Tracking</h1>
          <p>Curated technology opportunities from across the industry</p>
        </div>
        <JobsList jobs={jobsData} />
      </main>
      <Copyrights/>
      <Footer/>
    </>
  );
}
